// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2-kJv","upload":"Small_upload__2uYRs","imageWrap":"Small_imageWrap__3SnrP","removeBtn":"Small_removeBtn__3GE18"};